import SidebarContent from '@/components/generals/sidebar/sidebar-content'
import SidebarResizer from '@/components/generals/sidebar/sidebar-resizer'
import { useCrmStore } from '@/stores/crm-store-provider'

import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetTitle
} from '@/components/ui/sheet'

export default function Sidebar() {
    const sidebarOpen = useCrmStore(state => state.sidebarOpen)
    const setSidebarOpen = useCrmStore(state => state.setSidebarOpen)

    return (
        <>
            <aside className='relative hidden w-(--sidebar-width) shrink-0 border-r border-sidebar-border bg-sidebar lg:flex lg:flex-col'>
                <SidebarContent />
                <SidebarResizer />
            </aside>

            <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
                <SheetContent
                    side='left'
                    className='w-[254px] max-w-[85vw] border-sidebar-border bg-sidebar'
                >
                    <SheetTitle className='sr-only'>
                        Navigation
                    </SheetTitle>
                    <SheetDescription className='sr-only'>
                        Sales CRM sections and pipelines
                    </SheetDescription>
                    <SidebarContent />
                </SheetContent>
            </Sheet>
        </>
    )
}
